import {
    BLOCK_FIELD_TYPES,
    COMPARISON_DATA,
    DEVICE_NODE_SUPPORTED_TYPES,
    IDLE,
    INDEX_OF_VARIABLE_NAME,
    BUTTON_STATE_ITEM_NAME,
} from '../constants/MeshbotConstant';

export const getDataState = (data, dataItem) => {
    //Todo NEED REFACTORING
    return Object.entries(data).reduce((acc, [serial, controller]) => {
        if (
            serial === 'globalScenes' ||
            (!controller && Object.keys(controller).length === 0) ||
            !dataItem ||
            !controller[dataItem]
        ) {
            return acc;
        }

        return [
            ...acc,
            ...controller[dataItem]?.map((item) => {
                return { ...item, serial, isConnected: controller.isConnected, model: controller.model };
            }),
        ];
    }, []);
};

export const getSingleData = (data, serial) => data[serial];

export const setLocalStorage = (key, value) => {
    let val = value;
    if (typeof val === 'object') {
        try {
            val = JSON.stringify(val);
        } catch (err) {
            // eslint-disable-next-line
            console.error('Set Local Storage', err);
        }
    }
    localStorage.setItem(key, val);
};

export const getLocalStorage = (key) => {
    const data = localStorage.getItem(key);
    try {
        return JSON.parse(data);
    } catch (err) {
        return data;
    }
};

export const getNameCapability = (data) => {
    if (data.hasOwnProperty('parameters')) {
        return getNameCapability(data.parameters[0]);
    } else {
        return data.capability;
    }
};

export const getNameVariable = (data) => {
    if (data.hasOwnProperty('parameters')) {
        return getNameVariable(data.parameters[0]);
    } else {
        return data.variable;
    }
};

export const delLocalStorage = (key) => {
    localStorage.removeItem(key);
};

/**
 * Returns formatted name of string passed as argument.
 * Returns error if passed argument is no a string.
 * @param {string} name - not formatted capability name
 * @returns {string} with capital first letter and with spaces instead underscores
 * */

export const formatNameWithUnderscores = (name) => {
    if (typeof name === 'string') {
        return (name.charAt(0).toUpperCase() + name.slice(1)).split('_').join(' ');
    }
    throw new Error('Function #formatNameWithUnderscores expect string as name parameter');
};

/**
 * Checks if device item meets basic visibility and compatibility requirements
 * @param {Object} item - Device item to check
 * @param {string} deviceId - Target device ID for validation
 * @returns {boolean} True if item:
 *   - Is visible (show = true)
 *   - Has getter method (hasGetter = true)
 *   - Belongs to specified device (deviceId matches)
 *   - Has supported value type (valueType is in DEVICE_NODE_SUPPORTED_TYPES)
 */
export const isItemVisibleAndSupported = (item, deviceId) => {
    return (
        item.show &&
        item.hasGetter &&
        item.deviceId === deviceId &&
        DEVICE_NODE_SUPPORTED_TYPES.includes(item.valueType)
    );
};

/**
 * Determines if button_state item should be included based on firmware support
 * @param {Object} item - Device item to check
 * @param {boolean|null} isButtonStateItemSupported - Support flag:
 *   - When false, excludes 'button_state' items
 *   - Otherwise allows any valid item
 * @returns {boolean} True if:
 *   - Item is not 'button_state', OR
 *   - Firmware supports button_state items (isButtonStateItemSupported !== false)
 */
export const isButtonStateAllowed = (item, isButtonStateItemSupported) => {
    return isButtonStateItemSupported !== false || item.name !== BUTTON_STATE_ITEM_NAME;
};

/**
 * Filters device items based on visibility, device compatibility and firmware support.
 * Combines checks from `isItemVisibleAndSupported` and `isButtonStateAllowed`.
 * @param {Array<Object>} deviceItems - Array of device items to filter. Each item should contain:
 *   @property {boolean} show - Visibility flag
 *   @property {boolean} hasGetter - Availability of getter method
 *   @property {string} deviceId - Associated device ID
 *   @property {string} valueType - Type of the value (must be in DEVICE_NODE_SUPPORTED_TYPES)
 *   @property {string} name - Item name (e.g. 'button_state')
 * @param {string} deviceId - Target device ID for filtering
 * @param {boolean|null} [isButtonStateItemSupported] - Flag indicating if 'button_state' items should be included:
 *   - If false, excludes items with name 'button_state'
 *   - If null/true, no additional filtering by name
 * @returns {Array<Object>} Filtered array of device items meeting all conditions
 * @throws {Error} If deviceItems is not an array or deviceId is missing/empty
 */
export const getFilteredDeviceItemsForTrigger = (deviceItems, deviceId, isButtonStateItemSupported) => {
    if (!deviceId || !Array.isArray(deviceItems)) {
        throw new Error(
            'getFilteredDeviceItemsForTrigger: expected deviceItems (Array) and deviceId (string) as arguments',
        );
    }

    return deviceItems.filter(
        (item) => isItemVisibleAndSupported(item, deviceId) && isButtonStateAllowed(item, isButtonStateItemSupported),
    );
};

/**
 * Returns formatted text for comparator label.
 * Returns error if passed argument is no a string.
 * @param {object} comparatorObj - object with data related to comparator
 * @returns {string} formatted label text
 * */

export const generateComparatorLabel = (comparatorObj = {}) => {
    const { name, op: operator } = comparatorObj;

    if (name && operator) {
        return name === operator.split('_').join(' ')
            ? formatNameWithUnderscores(name)
            : `${formatNameWithUnderscores(name)} ( ${formatNameWithUnderscores(operator)} )`;
    }

    if (name) {
        return formatNameWithUnderscores(name);
    }
};

export const parseDataForUpdatePayload = (addedItem, foundDevice) => {
    return {
        _id: addedItem._id,
        abstract_uuid: foundDevice.name,
        variableName: addedItem.name,
    };
};

export const extractNameOfVariable = (item) => {
    return item.name.split('.')[INDEX_OF_VARIABLE_NAME];
};

export const getSelectedComparator = (event) => {
    return event.target.value?.name === BLOCK_FIELD_TYPES.BUTTON_STATE
        ? {
              method: COMPARISON_DATA.METHOD.IS_BUTTON_STATE,
          }
        : {};
};
export const getComparingValue = (event) => {
    return event.target.value?.name === BLOCK_FIELD_TYPES.BUTTON_STATE ? IDLE : 0;
};
